// extracted by mini-css-extract-plugin
export default {"tooltip":"ALMTooltip_tooltip__a6ZUh","showOnHover":"ALMTooltip_showOnHover__8tGxJ","almTooltip":"ALMTooltip_almTooltip__pTKMg"};